
import AWS from "aws-sdk";
import Tools from './Tools';
import UtilPub from './UtilPub';
import config from "@/utils/config";
import Api from "@/utils/api/Api";


export default class TianyiOss {
    static async doUpload(params: any): Promise<any> {
        let res = await Api.getTianyiOssKey({});//从后台拿取凭证
        let client = new AWS.S3({
            accessKeyId: res.accessKeyId,
            secretAccessKey: res.secretAccessKey,
            sessionToken: res.sessionToken,
            endpoint: res.endPoint,
        })
        client.putObject({
            ACL: "public-read",
            Bucket: res.bucketName,
            Body: params.file,
            Key: params.uploadName,
        }, async function (err: any, data: any) {
            if (err) {
                console.log(err)
                Tools.error({ message: "上传至天翼云失败" + err });
                params.loading.close();
            } else {
                await params.proxy.utilInst.buildParamsYun(res.bucketUrl + '/' + params.uploadName, params.uploadName, params, params.loading);
            }
        })
    }
    static async editorOssUpload(file: any, editor: any): Promise<any> {
        let res = await Api.getTianyiOssKey({});
        let client = new AWS.S3({
            accessKeyId: res.accessKeyId,
            secretAccessKey: res.secretAccessKey,
            sessionToken: res.sessionToken,
            endpoint: res.endpoint,
        })
        return new Promise((resolve, reject) => {
            let type = config.type ? config.type : 'product';
            let uploadName = `${type}` + '/editor/' + UtilPub.guid() + '-' + file.name;
            client.putObject({
                ACL: "public-read",
                Bucket: "bucket-shineray-dev-app",
                Body: file,
                Key: uploadName,
            }, async function (err: any, data: any) {
                if (err) {
                    Tools.info({ message: (err ? err : "上传失败!") });
                    reject({ result: false });
                } else {
                    let serverPath = res.bucketUrl + '/' + uploadName;
                    if (serverPath.indexOf('?') > -1) serverPath = serverPath.substr(0, serverPath.indexOf('?'));
                    editor.cmd.do('insertHTML', `<img src="${serverPath}" alt="">`);
                    resolve(serverPath);
                }
            })
        })
    }
}